import React from 'react';
import { CTAButton } from './CTAButton';
export function ValueStack() {
  const items = [{
    name: '📘 El Protocolo Blackout (Guía Principal)',
    price: '$197'
  }, {
    name: '🩺 BONUS 1: El Botiquín de Guerra Civil',
    price: '$97'
  }, {
    name: '🍳 BONUS 2: El Chef del Apagón',
    price: '$47'
  }, {
    name: '💰 BONUS 3: La Despensa de los $50',
    price: '$67'
  }, {
    name: '💧 BONUS 4: El Grifo Muerto',
    price: '$87'
  }, {
    name: '🧠 BONUS 5: Mente de Hierro',
    price: '$127'
  }];
  return <section id="precio" className="bg-[#0a0a0a] py-12 px-5" data-id="element-148">
      <div className="max-w-[800px] mx-auto" data-id="element-149">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold text-center mb-8 leading-[1.2]" data-id="element-150">
          Todo lo que recibís{' '}
          <span className="text-brand-orange" data-id="element-151">hoy mismo</span>
        </h2>

        <div id="comprar-ahora" className="bg-gradient-to-br from-[#111] to-[#1a1a1a] border-2 border-brand-orange rounded-2xl p-5 md:p-8 max-w-[700px] mx-auto shadow-[0_0_40px_rgba(255,87,51,0.2)]" data-id="element-152">
          <div className="space-y-0" data-id="element-153">
            {items.map((item, index) => <div key={index} className="flex justify-between items-center py-2.5 border-b border-[#222] last:border-0" data-id="element-154">
                <span className="text-[#ddd] text-sm md:text-[15px] flex-1 pr-4" data-id="element-155">
                  {item.name}
                </span>
                <span className="text-[#888] line-through text-sm shrink-0" data-id="element-156">
                  {item.price}
                </span>
              </div>)}
          </div>

          <div className="flex justify-between items-center pt-4 mt-2 border-t-2 border-brand-orange" data-id="element-157">
            <span className="font-oswald text-lg md:text-xl font-bold" data-id="element-158">
              VALOR TOTAL DEL PAQUETE
            </span>
            <span className="font-oswald text-xl md:text-2xl font-bold text-brand-orange" data-id="element-159">
              $100.000
            </span>
          </div>

          <div className="text-center mt-4 p-4 bg-brand-orange/10 rounded-lg" data-id="element-160">
            <p className="text-sm text-[#aaa] mb-1" data-id="element-161">
              TU PRECIO HOY (Oferta de Lanzamiento)
            </p>
            <p className="font-oswald text-5xl md:text-[56px] font-bold text-brand-orange leading-none mb-1" data-id="element-162">
              $19.999
            </p>
            <p className="text-[13px] text-[#888]" data-id="element-163">
              Pago único · Sin suscripción · Acceso de por vida
            </p>
          </div>
        </div>

        <div className="mt-6" data-id="element-164">
          <CTAButton href="https://pagos.indigo33.shop/cart/43955124207704:1" showPaymentMethods data-id="element-165">
            🛡️ SÍ, QUIERO PROTEGER A MI FAMILIA POR $19.999
          </CTAButton>
          <p className="text-[13px] text-[#888] text-center mt-2" data-id="element-166">
            🔒 Pago 100% seguro · Acceso instantáneo al descargar
          </p>
        </div>
      </div>
    </section>;
}